module.exports = __webpack_public_path__ + "static/media/users-highlight-admin-icon.633f0ca1.svg";